<span *ngIf="publishedDate$ | async as publishedDate">{{ publishedDate | date : 'yyy-MM-dd' }}</span>
